"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var units_1 = require("./units");
var Measure_1 = require("./Measure");
var _1 = require(".");
var CompatibilityFactory = /** @class */ (function () {
    function CompatibilityFactory() {
    }
    CompatibilityFactory.GetCompatibleUnits = function (a1, specificGravity) {
        var compatibleUnits = [];
        if (a1 instanceof Measure_1.Measure) {
            var measure_1 = a1;
            if (measure_1 instanceof _1.AreaMeasure) {
                compatibleUnits.push.apply(compatibleUnits, this.GetUnitAliases('area'));
            }
            else if (measure_1 instanceof _1.LengthMeasure) {
                compatibleUnits.push.apply(compatibleUnits, this.GetUnitAliases('length'));
            }
            else if (measure_1 instanceof _1.MassAndWeightMeasure) {
                compatibleUnits.push.apply(compatibleUnits, this.GetUnitAliases('massandweight'));
                if (measure_1.Density) {
                    compatibleUnits.push.apply(compatibleUnits, this.GetUnitAliases('volume'));
                }
            }
            else if (measure_1 instanceof _1.PowerMeasure) {
                compatibleUnits.push.apply(compatibleUnits, this.GetUnitAliases('power'));
            }
            else if (measure_1 instanceof _1.VolumeMeasure) {
                compatibleUnits.push.apply(compatibleUnits, this.GetUnitAliases('volume'));
                if (measure_1.Density) {
                    compatibleUnits.push.apply(compatibleUnits, this.GetUnitAliases('massandweight'));
                }
            }
            else if (measure_1 instanceof _1.PackageMeasure) {
                compatibleUnits.push(measure_1.Unit.FullDisplay);
                var subCollection = this.GetCompatibleUnits(measure_1.Unit.PartUnit.Unit);
                compatibleUnits.push.apply(compatibleUnits, subCollection.map(function (unit) {
                    return new _1.PartUnit(unit, measure_1.Unit).Unit.FullDisplay;
                }));
            }
        }
        else {
            var unit_1 = a1;
            if (unit_1 instanceof _1.AreaUnit) {
                compatibleUnits.push.apply(compatibleUnits, this.GetUnitAliases('area'));
            }
            else if (unit_1 instanceof _1.LengthUnit) {
                compatibleUnits.push.apply(compatibleUnits, this.GetUnitAliases('length'));
            }
            else if (unit_1 instanceof _1.MassAndWeightUnit) {
                compatibleUnits.push.apply(compatibleUnits, this.GetUnitAliases('massandweight'));
                if (specificGravity && specificGravity > 0) {
                    compatibleUnits.push.apply(compatibleUnits, this.GetUnitAliases('volume'));
                }
            }
            else if (unit_1 instanceof _1.PackageUnit) {
                compatibleUnits.push(unit_1.PartUnit.Unit.FullDisplay);
                var subCollection = this.GetCompatibleUnits(unit_1.PartUnit.Unit, specificGravity);
                compatibleUnits.push.apply(compatibleUnits, subCollection.map(function (subUnit) {
                    return new _1.PartUnit(subUnit, unit_1).Unit.FullDisplay;
                }));
            }
            else if (unit_1 instanceof _1.PowerUnit) {
                compatibleUnits.push.apply(compatibleUnits, this.GetUnitAliases('power'));
            }
            else if (unit_1 instanceof _1.PressureUnit) {
                compatibleUnits.push.apply(compatibleUnits, this.GetUnitAliases('pressure'));
            }
            else if (unit_1 instanceof _1.TimeUnit) {
                compatibleUnits.push.apply(compatibleUnits, this.GetUnitAliases('time'));
            }
            else if (unit_1 instanceof _1.VolumeUnit) {
                compatibleUnits.push.apply(compatibleUnits, this.GetUnitAliases('volume'));
                if (specificGravity && specificGravity > 0) {
                    compatibleUnits.push.apply(compatibleUnits, this.GetUnitAliases('massandweight'));
                }
            }
        }
        return compatibleUnits;
    };
    CompatibilityFactory.GetAllUnits = function () {
        var allUnits = {};
        // eslint-disable-next-line no-restricted-syntax
        for (var i = 0; i < Object.keys(units_1.unitsByMeasure).length; i += 1) {
            var measure = Object.keys(units_1.unitsByMeasure)[i];
            var measureUnitKeys = this.GetUnitAliases(measure);
            for (var j = 0; j < measureUnitKeys.length; j += 1) {
                var key = measureUnitKeys[j];
                allUnits[key] = units_1.unitsByMeasure[measure][key];
            }
        }
        return allUnits;
    };
    CompatibilityFactory.GetAllUnitAliases = function () {
        var allUnits = [];
        // eslint-disable-next-line no-restricted-syntax
        for (var i = 0; i < Object.keys(units_1.unitsByMeasure).length; i += 1) {
            var measure = Object.keys(units_1.unitsByMeasure)[i];
            allUnits.push.apply(allUnits, this.GetUnitAliases(measure));
        }
        return allUnits.sort();
    };
    CompatibilityFactory.GetUnitAliases = function (measure) {
        return Array.from(new Set(Object.keys(units_1.unitsByMeasure[measure])));
    };
    return CompatibilityFactory;
}());
exports.CompatibilityFactory = CompatibilityFactory;
